import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import pxToRem from 'styles/pxToRem';

const styles = () => ({
  title: {
    display: 'inline-flex',
    maxWidth: '100%',
    alignItems: 'center',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    padding: 10,
    margin: -10,
    verticalAlign: 'top',
  },
  titleText: {
    alignItems: 'center',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    fontSize: pxToRem(22),
  },
  button: {
    marginRight: 24,
    '& $iconArrowLeft': {
      marginRight: 0,
    },
  },
  iconArrowLeft: {
    width: 16,
    height: 16,
    marginRight: 18,
  },
  link: {
    display: 'block',
  },
});

const ScheduleCalendarFilterDateOfDeliveryFields = ({
  className,
  ...otherProps
}) => {
  if (!otherProps['Date of Delivery From'].input.value
    && !otherProps['Date of Delivery To'].input.value) {
    return '';
  }
  return (
    <div className={className}>
      <Typography>
        Date of Delivery:
        {' '}
        {otherProps['Date of Delivery From'].input.value} - {otherProps['Date of Delivery To'].input.value}
      </Typography>
    </div>
  );
};

ScheduleCalendarFilterDateOfDeliveryFields.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({
    title: PropTypes.string.isRequired,
    titleText: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
    iconArrowLeft: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
  }).isRequired,
};

ScheduleCalendarFilterDateOfDeliveryFields.defaultProps = {
  className: '',
};

export default withStyles(styles)(ScheduleCalendarFilterDateOfDeliveryFields);



// WEBPACK FOOTER //
// ./src/components/schedule/ScheduleCalendarFilter/ScheduleCalendarFilterDateOfDeliveryFields.js